module.exports = __webpack_public_path__ + "media/images/mobile/logo_s_q-1d45c187acd21177b61c273cfe4008ba.gif";